import { render, staticRenderFns } from "./form-comment.vue?vue&type=template&id=7cdad248&scoped=true&"
import script from "./form-comment.vue?vue&type=script&lang=js&"
export * from "./form-comment.vue?vue&type=script&lang=js&"
import style0 from "./form-comment.vue?vue&type=style&index=0&id=7cdad248&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdad248",
  null
  
)

export default component.exports